import type { TenantFeatures } from "breuer-supercharged-sdk";

/** Entries of the "Funktionen" sidebar group; `feature: null` = always visible. */
export interface FeatureNavEntry {
  key: string;
  label: string;
  path: string;
  feature: TenantFeatures | null;
}

export const FEATURE_NAV_ENTRIES: readonly FeatureNavEntry[] = [
  { key: "pdf_scanner_v4", label: "PDF2BVBS", path: "/pdf_scanner_v4", feature: "stücklisten_extractor" },
  { key: "offer_generation", label: "Angebote erstellen", path: "/offer_generation", feature: "offer_generation" },
  { key: "steel_mind", label: "SteelMind", path: "/steel_mind", feature: "steel_mind" },
  { key: "order_inbox", label: "Bestelleingang", path: "/order_inbox", feature: "order_inbox" },
  // AV-Dashboard (Vision §5 MVP) — Bestellungs-Detail is reached from here and from the Bestelleingang.
  { key: "arbeitsvorbereitung", label: "Arbeitsvorbereitung", path: "/arbeitsvorbereitung", feature: null },
];

export function visibleFeatureNavEntries(hasFeature: (feature: TenantFeatures) => boolean): FeatureNavEntry[] {
  return FEATURE_NAV_ENTRIES.filter((entry) => entry.feature === null || hasFeature(entry.feature));
}

/** „Verwaltung“-Eintrag nur für Prüfer; `pending` speist das Zähler-Badge. */
export interface ManagementNavEntry {
  key: string;
  label: string;
  path: string;
  badge?: number;
}

export const FEEDBACK_REVIEW_PATH = "/feedback-review";

export function feedbackReviewNavEntry(currentUserIsReviewer: boolean, pending: number): ManagementNavEntry | null {
  if (!currentUserIsReviewer) return null;
  return {
    key: "feedback-review",
    label: "Feedback-Prüfung",
    path: FEEDBACK_REVIEW_PATH,
    ...(pending > 0 ? { badge: pending } : {}),
  };
}
